import React, {useEffect, useRef, useState} from 'react'
import axios from "axios";
import {FLEET_MS_API_URL} from "@constants/index";
import Cookies from "js-cookie";
import {CustomHeader, FlexInnerComponent,} from "@pages/new-design-components/custom-components";
import CustomSearch from "@pages/components/CustomSearch";
import {useHistory} from "react-router-dom";
import QuotesTable from "@pages/new-design-components/QuotesTable";
import {ClipLoader} from "react-spinners";
import {LoaderContainer, override} from "@pages/reusable-components/styled-components";

export default function  RepairQuote() {
    const history = useHistory();
    const [token, setToken] = useState('');
    const [filter, setFilter] = useState({})
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(true)

    const keys =
        [

            {
                key: 'vehicle_make',
                text: 'Manufacturer'
            },
            {
                key: 'vehicle_model',
                text: 'Model'
            },
            {
                key: 'stock_no',
                text: 'Reg. No.'
            },
            {
                key: 'status',
                text: 'Status',
            },
            {
                key: 'options',
                text: ''
            },
        ];
    const fetchData =  (token,page = 1,filter = {}) => {
             axios({
                method: 'GET',
                url: `${FLEET_MS_API_URL}/fleet-management/fleet-quotes`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: filter ? filter : '',
            }).then(response=>{
                 const data = response.data?.data
                 setTableData(data)
                 setLoading(false)
             }).catch(()=> {
                 setLoading(false)
             })
    }

    const goToDetails =  (index) => {
        const data = tableData[index]
        history.push({
            pathname: `/admin/vehicle-quote-preview`,
            state: {
                vehicleId: data.vehicle_id,
                fleetId: data.fleet_id,
                quoteId: data.id
            }
        })
    }

    useEffect(()=>{
        const grs_token = Cookies.get('grs_token')
        setToken(grs_token)
        fetchData(grs_token)
    },[])

    const searchData = async (key,value) => {
        const tempFilter = {...filter}
        tempFilter[key] = value
        setFilter(tempFilter)
        setLoading(true)
        await fetchData(token,1,tempFilter)
    }
    return (
        loading ?

            <LoaderContainer>
                <ClipLoader
                    size={40}
                    color={`#7B61E4`}
                />
            </LoaderContainer>

            :

           <div className={'container-fluid mt-3'}>
            <CustomHeader className={'mb-5'}>
                Vehicles
            </CustomHeader>
            <div className={'d-flex g-10'}>
                <FlexInnerComponent width={33}>
                    <CustomSearch
                        defaultValue={filter.search || ''}
                        onChange={(e) => {
                            searchData('search', e.target.value)
                        }}
                        placeholder="Search"
                    />
                </FlexInnerComponent>
            </div>
            <QuotesTable
                keys={keys}
                showQuickView={false}
                goToDetails={goToDetails}
                withoutDelete={true}
                tableData={tableData}
            />
        </div>
    )
}